import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { useFormik } from "formik";
import { toast } from 'react-hot-toast';
import * as Yup from "yup";
import axios from 'axios';
import { FocusError } from 'focus-formik-error';
import { useDispatch, useSelector } from 'react-redux';
import { getCityData, getCountryData, getHomeCategoryData, getStateData, getSubCategoryData } from '../../../../Redux/action/MasterAction';
import 'react-phone-number-input/style.css'
import PhoneInput, { parsePhoneNumber, getCountryCallingCode } from 'react-phone-number-input'
import HourglassLoader from '../../../../Common/HourglassLoader';
import { Modal } from "react-bootstrap";
import ReCAPTCHA from "react-google-recaptcha";

const host = process.env.REACT_APP_API_SERVER;
const siteKey = process.env.REACT_APP_SITE_KEY;

const TutorRegister = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [cphone, setPhone] = useState('');
    const [captchaToken, setCaptchaToken] = useState(null);
    const [captchaError, setCaptchaError] = useState("");
    const captchaRef = React.useRef(null); 
    const [showModal, setShowModal] = useState(false);


    const [faIcon3, setfaIcon3] = useState('fa-eye-slash');
    const togglePasswordType3 = () => {
        let input_pass = document.getElementById('password-field_3');
        const toggle_pass = document.getElementById("toggle_pass_3");
        let input_type = input_pass.getAttribute('type');
        if (input_type == "password") {
            setfaIcon3('fa-eye');
            input_pass.type = "text";
        } else {
            setfaIcon3('fa-eye-slash')
            input_pass.type = "password"
        }
    }
    const [faIcon4, setfaIcon4] = useState('fa-eye-slash');
    const togglePasswordType4 = () => {
        let input_pass = document.getElementById('password-field_4');
        const toggle_pass = document.getElementById("toggle_pass_4");
        let input_type = input_pass.getAttribute('type');
        if (input_type == "password") {
            setfaIcon4('fa-eye');
            input_pass.type = "text";
        } else {
            setfaIcon4('fa-eye-slash')
            input_pass.type = "password"
        }
    }

    useEffect(() => {

        dispatch(getCountryData());
        dispatch(getHomeCategoryData())
    }, []);


    const handleClassChange = (e) => {
        const id = e.target.value

        dispatch(getSubCategoryData(id))
    }

    const {

        //country
        loadingCountryDataListApi,
        CountryDataListApiData,
        CountryDataListApiError,

        //state
        loadingStateDataListApi,
        StateDataListApiData,
        StateDataListApiError,

        //city
        loadingCityDataListApi,
        CityDataListApiData,
        CityDataListApiError,


        loadingCategoryDataListApi,
        CategoryDataListApiData,
        CategoryDataListApiError,


        loadingSubCategoryListApi,
        SubCategoryListApiData,
        SubCategoryListApiError,

    } = useSelector(state => state?.MasterReducer);

    let [initialValues, setInitialValues] = useState({

        firstName: "",
        lastName: "",
        country_code: "",
        mobile: "",
        email: "",
        dob: "",
        gender: "",
        password: "",
        cpassword: "",
        about_the_tutor: "",
        country_id: "",
        state_id: "",
        city_id: "",
        address_line_1: "",
        address_line_2: "",
        zip_code: "",


        specialization: "",
        qualifications: "",
        experience: "",
        tutoring_location: "",
        language: "",
        per_session_price_one_to_one: "",
        per_session_price_group: "",

        teaching_type_id: "",
        category_id: "",
        sub_category_id: "",


        educational_degree: "",
        certification: "",
        kyc_document: "",


        account_holder: "",
        account_number: "",
        wire_transfer_no: "",
        bank_code: "",
        routing_no: ""

    })

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: Yup.object().shape({

            firstName: Yup.string().required("First name is required").matches(/^[a-zA-Z .]+$/, "Name can only contain letters."),
            email: Yup.string().required("Email is required.").matches(/^\w+[-\.\w]*@(?!(?:)\.com$)\w+[-\.\w]*?\.\w{2,4}$/, "Enter a valid E-mail"),
            mobile: Yup.string().required("Phone number is required")
                .matches(/^[1-9][0-9]{7,14}$/, "Please enter a valid Mobile Number."),
            country_code: Yup.string().required("Country Code is required"),
            about_the_tutor: Yup.string().required("About the tutor is required"),
            password: Yup.string()
                .required("Password is required")
                .min(6, "Password must be at least 6 characters long"),
            cpassword: Yup.string()
                .oneOf([Yup.ref('password'), null], 'Passwords must match')
                .required("Confirm password is required"),
            country_id: Yup.string().required("Country is required"),


            dob: Yup.date()
                .max(new Date(), 'Date of birth cannot be in the future')
                .test('is-at-least-18', 'Must be at least 18 years old', function (value) {
                    const today = new Date();
                    const userBirthDate = new Date(value);
                    const age = today.getFullYear() - userBirthDate.getFullYear();
                    return age >= 18;
                })
                .required('Please select date of birth.'),
            state_id: Yup.string().required("State is required"),
            city_id: Yup.string().required("City is required"),
            address_line_1: Yup.string().required("Address line 1 is required"),
            // address_line_2: Yup.string().required("Address line 2 is required"),
            zip_code: Yup.string().required("Zip code is required").matches(/^[0-9]+$/, "Please enter a valid Zip Code."),
            per_session_price_one_to_one: Yup.number()
                .typeError("Session price one to one must be a number")
                .required("Session price one to one is required")
                .positive("Session price one to one must be greater than zero"),
            per_session_price_group: Yup.number()
                .typeError("Session price group must be a number")
                .required("Session price group is required")
                .positive("Session price group must be greater than zero"),

            // specialization: Yup.string().required("Specialization is required"),
            // qualifications: Yup.string().required("Qualifications is required"),
            // experience: Yup.string().required("Experience in yrs is required"),
            // tutoring_location: Yup.string().required("Tutoring in location is required"),
            // language: Yup.string().required("Class language is required"),
            // teaching_type_id: Yup.string().required("Selecting type of class is required"),
            // category_id: Yup.string().required("Selecting class is required"),
            // sub_category_id: Yup.string().required("Selecting subject is required"),
            // educational_degree: Yup.string().required("Educational details is required"),
            // certification: Yup.string().required("Certification is required"),
            // kyc_document: Yup.string().required("KYC Document is required"),
            // account_holder: Yup.string().required("Account Holder Name is required"),
            // account_number: Yup.string().required("Account number is required"),
            // wire_transfer_no: Yup.string().required("Wire transfer number is required"),
            // bank_code: Yup.string().required("Bank Code(SWIFT/BIC) is required"),
            // routing_no: Yup.string().required("Routing Number(ACH or ABA) is required"),


        }),
        onSubmit: (values, { setSubmitting, resetForm }) => {

            try {

                if (!captchaToken) {
                    setCaptchaError("Please complete the CAPTCHA.");
                    return;
                }

                setSubmitting(true);
                let config = {
                    headers: {

                        'Content-Type': 'multipart/form-data',
                    },
                };
                const formData = new FormData();
                formData.append("name", `${values.firstName} ${values.lastName}`);
                formData.append("email", values.email)
                formData.append("mobile", values.mobile)
                formData.append("country_code", values.country_code)
                formData.append("dob", values.dob)
                formData.append("gender", values.gender)
                formData.append("password", values.password)
                formData.append("about_the_tutor", values.about_the_tutor)
                formData.append("country_id", values.country_id)
                formData.append("state_id", values.state_id)
                formData.append("city_id", values.city_id)
                formData.append("address_line_1", values.address_line_1)
                formData.append("address_line_2", values.address_line_2)
                formData.append("zip_code", values.zip_code)
                formData.append("per_session_price_one_to_one", values.per_session_price_one_to_one)
                formData.append("per_session_price_group", values.per_session_price_group)
                formData.append("captchaToken", captchaToken)
                // formData.append("specialization", values.specialization)
                // formData.append("qualifications", values.qualifications)
                // formData.append("experience", values.experience)
                // formData.append("tutoring_location", values.tutoring_location)
                // formData.append("language", values.language)

                // formData.append("teaching_type_id", values.teaching_type_id)
                // formData.append("category_id", values.category_id)
                // formData.append("sub_category_id", values.sub_category_id)
                // formData.append("educational_degree", values.educational_degree)
                // formData.append("certification", values.certification)
                // formData.append("kyc_document", values.kyc_document)
                // formData.append("account_holder", values.account_holder)
                // formData.append("account_number", values.account_number)
                // formData.append("wire_transfer_no", values.wire_transfer_no)
                // formData.append("bank_code", values.bank_code)
                // formData.append("routing_no", values.routing_no)


                axios.post(`${host}/api/web/tutor-register`, formData, config)

                    .then(res => {

                        if (res.status == 200) {

                            toast.success(res.data.message);
                            setSubmitting(false);
                            if(res.data.create){
                                setShowModal(true);
                            setTimeout(() => {
                                setShowModal(false);
                                navigate('/')
                            }, [3000])
                               
                               
                            }
                           else{
                            navigate('/login', { state: { user: 'tutor' } })
                           }
                           
                        } else {
                            if (captchaRef.current) {
                                captchaRef.current.reset(); // Reset the CAPTCHA
                            }
                            setCaptchaToken(null);
                            toast.error(res.data.message);
                            setSubmitting(false);
                        }
                    }).catch(err => {
                        if (captchaRef.current) {
                            captchaRef.current.reset(); // Reset the CAPTCHA
                        }
                        setCaptchaToken(null);
                        if (err.response) {
                            toast.error(err.response.data.message);
                        } else {
                            toast.error("Internal server error.")
                        }
                        setSubmitting(false);
                    });

            }
            catch (error) {

                if (captchaRef.current) {
                    captchaRef.current.reset(); // Reset the CAPTCHA
                }
                setCaptchaToken(null);
                toast.error(error.response.data.message);
                setSubmitting(false);

            }

        }
    })

    const handleNavigation = () => {
        navigate('/login', { state: { user: 'tutor' } })
    }


    const handleEducationalDetailFileChange = (e) => {
        const file = e.target.files[0]; // Get the first file
        if (file) {
            formik.setFieldValue('educational_degree', file); // Update formik field value

        }
    };

    const handleCertificationFileChange = (e) => {
        const file = e.target.files[0]; // Get the first file
        if (file) {
            formik.setFieldValue('certification', file); // Update formik field value

        }
    };

    const handleKycDocFileChange = (e) => {
        const file = e.target.files[0]; // Get the first file
        if (file) {
            formik.setFieldValue('kyc_document', file); // Update formik field value

        }
    };

    const handleCountryChange = (e) => {
        const id = e.target.value
        formik.setFieldValue('state_id', '')
        formik.setFieldValue('city_id', '')

        if (id == '') {
            dispatch(getStateData('0'))
        }
        else {
            dispatch(getStateData(id))
        }
        dispatch(getCityData(0))
    }

    const handleStateChange = (e) => {
        const id = e.target.value
        formik.setFieldValue('city_id', '')
        if (id == '') {
            dispatch(getCityData('0'))
        }
        else {
            dispatch(getCityData(id))
        }
    }
    const handleCaptcha = (token) => {
        setCaptchaToken(token);
        setCaptchaError("");
    };

    return (
        <div className="form-body ">
            <form onSubmit={formik.handleSubmit} method='post'>
                <FocusError formik={formik} />
                <div className="mb-3 row">
                    <div className="accordion" id="accordionExample">
                        <div className="accordion-item">
                            <h2 className="accordion-header" id="headingOne">
                                <button
                                    className="accordion-button"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#collapseOne"
                                    aria-expanded="true"
                                    aria-controls="collapseOne"
                                >
                                    <strong>Personal Details</strong>
                                </button>
                            </h2>
                            <div
                                id="collapseOne"
                                className="accordion-collapse collapse show"
                                aria-labelledby="headingOne"
                                data-bs-parent="#accordionExample"
                            >
                                <div className="accordion-body">
                                    <div className="row">
                                        <div className="col-lg-6 col-md-6 col-sm-12 mb-3">
                                            <label
                                                htmlFor="exampleFormControlInput1"
                                                className="form-label"
                                            >
                                                First Name<span className="text-danger">*</span>
                                            </label>
                                            <input
                                                maxLength={20}
                                                type="text"
                                                className="input-form"
                                                id="exampleFormControlInput1"
                                                placeholder="Enter your full name"
                                                name='firstName'
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.firstName}
                                            />
                                            <div className="help-block with-errors">
                                                {formik.touched.firstName && formik.errors.firstName ? (
                                                    <div className='text-danger'>{formik.errors.firstName}</div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-12 mb-3">
                                            <label
                                                htmlFor="exampleFormControlInput1"
                                                className="form-label"
                                            >
                                                Last Name
                                            </label>
                                            <input
                                                maxLength={20}
                                                type="text"
                                                className="input-form"
                                                id="exampleFormControlInput1"
                                                placeholder="Enter your last name"
                                                name='lastName'
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.lastName}
                                            />
                                            <div className="help-block with-errors">
                                                {formik.touched.lastName && formik.errors.lastName ? (
                                                    <div className='text-danger'>{formik.errors.lastName}</div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <label htmlFor="mobile">Phone Number<span className="text-danger">*</span></label>
                                            <div className="row">
                                                <div className="col-md-5">
                                                    <select className='form-select' name='country_code' onChange={(e) => {
                                                        formik.handleChange(e);

                                                    }}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.country_code}>
                                                        <option value="">--Select--</option>
                                                        {CountryDataListApiData?.map((data) => (
                                                            <option value={data?.phone_code}>{data?.sort_name} ({data?.phone_code})</option>
                                                        ))}

                                                    </select>
                                                </div>
                                                <div className="col-md-7">
                                                    <input
                                                        maxLength={12}
                                                        type="text"
                                                        className="input-form"
                                                        id="exampleFormControlInput1"
                                                        placeholder="Enter your phone number"
                                                        name='mobile'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.mobile}
                                                    />
                                                </div>
                                            </div>
                                            {/* <PhoneInput
                                                limitMaxLength={10}
                                                id="mobile"
                                                className="input-form"
                                                placeholder="Enter your phone number"
                                                defaultCountry="IN"
                                                name="mobile"
                                                value={formik.values.mobile} // Bind Formik's value to PhoneInput
                                                onChange={(value) => formik.setFieldValue('mobile', value)} // Update Formik's value
                                            /> */}
                                            <div className="help-block with-errors">
                                                {formik.touched.mobile && formik.errors.mobile ? (
                                                    <div className='text-danger'>{formik.errors.mobile}</div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-12 mb-3">
                                            <label
                                                htmlFor="exampleFormControlInput1"
                                                className="form-label"
                                            >
                                                Email ID<span className="text-danger">*</span>
                                            </label>
                                            <input
                                                maxLength={100}
                                                type="email"
                                                className="input-form"
                                                id="exampleFormControlInput1"
                                                placeholder="Enter your email id"
                                                name='email'
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.email}
                                            />
                                            <div className="help-block with-errors">
                                                {formik.touched.email && formik.errors.email ? (
                                                    <div className='text-danger'>{formik.errors.email}</div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-12">
                                            <label
                                                htmlFor="exampleFormControlInput1"
                                                className="form-label"
                                            >
                                                Date of birth<span className="text-danger">*</span>
                                            </label>
                                            <input
                                                type="date"
                                                className="input-form"
                                                id="exampleFormControlInput1"
                                                placeholder="Enter your dob"
                                                name='dob'
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.dob}
                                                max={new Date().toISOString().split("T")[0]}
                                                onKeyDown={(e) => e.preventDefault()}
                                            />
                                            <div className="help-block with-errors">
                                                {formik.touched.dob && formik.errors.dob ? (
                                                    <div className='text-danger'>{formik.errors.dob}</div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-12">
                                            <label
                                                htmlFor="exampleFormControlInput1"
                                                className="form-label"
                                            >
                                                Gender
                                            </label>
                                            <select name="gender" id="gender"

                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.gender}>
                                                <option value=''>-Select-</option>
                                                <option value="Male">Male</option>
                                                <option value="Female">Female</option>
                                                <option value="Other">Other</option>
                                            </select>
                                            <div className="help-block with-errors">
                                                {formik.touched.gender && formik.errors.gender ? (
                                                    <div className='text-danger'>{formik.errors.gender}</div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-12">
                                            <div>
                                                <label htmlFor="inputPass" className="form-label">

                                                    Password<span className="text-danger">*</span>
                                                </label>
                                                <div className="input-group">
                                                    <input
                                                        maxLength={10}
                                                        placeholder="Enter Your Password"
                                                        id="password-field_3"
                                                        type="password"
                                                        className="input-form"
                                                        name="password"
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.password}
                                                    />
                                                    <i
                                                        toggle="#password-field_3" className={`fa-regular ${faIcon3} field-icon toggle-password `} id="toggle_pass" onClick={togglePasswordType3}
                                                    />

                                                </div>
                                                <div className="help-block with-errors">
                                                    {formik.touched.password && formik.errors.password ? (
                                                        <div className='text-danger'>{formik.errors.password}</div>
                                                    ) : null}
                                                </div>
                                                {/* <span id="confirm-password-message" class="error-message"></span><br> */}
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-12">
                                            <div>
                                                <label htmlFor="vendorPassword" className="form-label">
                                                    Confirm Password<span className="text-danger">*</span>
                                                </label>
                                                <div className="input-group">
                                                    <input
                                                        maxLength={10}
                                                        placeholder="Confirm Password"
                                                        id="password-field_4"
                                                        type="password"
                                                        className="input-form"
                                                        name="cpassword"
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.cpassword}
                                                    />
                                                    <i
                                                        toggle="#password-field_4" className={`fa-regular ${faIcon4} field-icon toggle-password `} id="toggle_pass" onClick={togglePasswordType4}
                                                    />

                                                </div>
                                                <div className="help-block with-errors">
                                                    {formik.touched.cpassword && formik.errors.cpassword ? (
                                                        <div className='text-danger'>{formik.errors.cpassword}</div>
                                                    ) : null}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-lg-6 col-md-6 col-sm-12 mb-3">
                                            <label
                                                htmlFor="exampleFormControlInput1"
                                                className="form-label"
                                            >
                                                Address Line-1<span className="text-danger">*</span>
                                            </label>
                                            <input
                                                maxLength={200}
                                                type="text"
                                                className="input-form"
                                                id="exampleFormControlInput1"
                                                placeholder="Enter your address line-1"
                                                name='address_line_1'
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.address_line_1}
                                            />
                                            <div className="help-block with-errors">
                                                {formik.touched.address_line_1 && formik.errors.address_line_1 ? (
                                                    <div className='text-danger'>{formik.errors.address_line_1}</div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-12 mb-3">
                                            <label
                                                htmlFor="exampleFormControlInput1"
                                                className="form-label"
                                            >
                                                Address Line-2
                                            </label>
                                            <input
                                                maxLength={200}
                                                type="text"
                                                className="input-form"
                                                id="exampleFormControlInput1"
                                                placeholder="Enter your address line-2"
                                                name='address_line_2'
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.address_line_2}
                                            />
                                            <div className="help-block with-errors">
                                                {formik.touched.address_line_2 && formik.errors.address_line_2 ? (
                                                    <div className='text-danger'>{formik.errors.address_line_2}</div>
                                                ) : null}
                                            </div>
                                        </div>

                                        <div className="col-lg-6 col-md-6 col-sm-12">
                                            <label
                                                htmlFor="exampleFormControlInput1"
                                                className="form-label"
                                            >
                                                Country<span className="text-danger">*</span>
                                            </label>
                                            <select name='country_id' onChange={(e) => {
                                                formik.handleChange(e);
                                                handleCountryChange(e)
                                            }}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.country_id}>
                                                <option value=""> --Select Country--</option>
                                                {CountryDataListApiData?.map((data) => (
                                                    <option value={data?.id}>{data?.name}</option>
                                                ))}

                                            </select>
                                            <div className="help-block with-errors">
                                                {formik.touched.country_id && formik.errors.country_id ? (
                                                    <div className='text-danger'>{formik.errors.country_id}</div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-12">
                                            <label
                                                htmlFor="exampleFormControlInput1"
                                                className="form-label"
                                            >
                                                State<span className="text-danger">*</span>
                                            </label>
                                            <select name='state_id' onChange={(e) => {
                                                formik.handleChange(e);
                                                handleStateChange(e)
                                            }}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.state_id}>
                                                <option selected="" disabled="" value="">
                                                    --Select State--
                                                </option>
                                                {StateDataListApiData?.map((data) => (
                                                    <option value={data?.id}>{data?.name}</option>
                                                ))}
                                            </select>
                                            <div className="help-block with-errors">
                                                {formik.touched.state_id && formik.errors.state_id ? (
                                                    <div className='text-danger'>{formik.errors.state_id}</div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-12">
                                            <label htmlFor="exampleFormControlInput1">City<span className="text-danger">*</span></label>
                                            <select name="city_id" id="city"

                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.city_id}>
                                                <option selected="" disabled="" value="">
                                                    --Select City--
                                                </option>
                                                {CityDataListApiData?.map((data) => (
                                                    <option value={data?.id}>{data?.name}</option>
                                                ))}
                                            </select>
                                            <div className="help-block with-errors">
                                                {formik.touched.city_id && formik.errors.city_id ? (
                                                    <div className='text-danger'>{formik.errors.city_id}</div>
                                                ) : null}
                                            </div>
                                        </div>

                                        <div className="col-lg-6 col-md-6 col-sm-12 mb-3">
                                            <label
                                                htmlFor="exampleFormControlInput1"
                                                className="form-label"
                                            >
                                                Zip code<span className="text-danger">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="input-form"
                                                id="exampleFormControlInput1"
                                                placeholder="Enter your zip code"
                                                name='zip_code'
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.zip_code}
                                                maxLength={6}
                                                minLength={4}
                                            />
                                            <div className="help-block with-errors">
                                                {formik.touched.zip_code && formik.errors.zip_code ? (
                                                    <div className='text-danger'>{formik.errors.zip_code}</div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-12 mb-3">
                                            <label
                                                htmlFor="exampleFormControlInput1"
                                                className="form-label"
                                            >
                                                Session price one to one(in dollars)<span className="text-danger">*</span>
                                            </label>
                                            <input
                                                maxLength={6}
                                                type="text"
                                                className="input-form"
                                                id="exampleFormControlInput1"
                                                placeholder="Enter your session price one to one"
                                                name='per_session_price_one_to_one'
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.per_session_price_one_to_one}
                                            />
                                            <div className="help-block with-errors">
                                                {formik.touched.per_session_price_one_to_one && formik.errors.per_session_price_one_to_one ? (
                                                    <div className='text-danger'>{formik.errors.per_session_price_one_to_one}</div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-12 mb-3">
                                            <label
                                                htmlFor="exampleFormControlInput1"
                                                className="form-label"
                                            >
                                                Session price group(in dollars)<span className="text-danger">*</span>
                                            </label>
                                            <input
                                                maxLength={6}
                                                type="text"
                                                className="input-form"
                                                id="exampleFormControlInput1"
                                                placeholder="Enter your session price group"
                                                name='per_session_price_group'
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.per_session_price_group}
                                            />
                                            <div className="help-block with-errors">
                                                {formik.errors.per_session_price_group ? (
                                                    <div className='text-danger'>{formik.errors.per_session_price_group}</div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-lg-12 col-md-12 col-sm-12">
                                            <label
                                                htmlFor="exampleFormControlInput1"
                                                className="form-label"
                                            >
                                                About the Tutor<span className="text-danger">*</span>
                                            </label>
                                            <textarea
                                                className="input-form"
                                                id="exampleFormControlInput1"
                                                placeholder="Enter about the Tutor"

                                                defaultValue={
                                                    "                                                                    "
                                                }
                                                name='about_the_tutor'
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.about_the_tutor}
                                            />
                                            <div className="help-block with-errors">
                                                {formik.touched.about_the_tutor && formik.errors.about_the_tutor ? (
                                                    <div className='text-danger'>{formik.errors.about_the_tutor}</div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className='col-lg-12 col-md-12 col-sm-12'>
                                        <ReCAPTCHA
                sitekey={siteKey}
                onChange={handleCaptcha}
                ref={captchaRef} // Attach the ref to the CAPTCHA
            />
            {captchaError && <div className="text-danger">{captchaError}</div>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>

                <div className="mb-3 row">
                    <div className="col-sm-12 mb-3 text-center">

                        <button
                            type="submit"
                            disabled={formik.isSubmitting}
                            className="login-btn fw-bold"
                            style={{ color: "white !important" }}
                        >
                            {formik.isSubmitting ? <HourglassLoader /> : 'Register'}
                        </button>
                        {/* <button type="submit" class="login-btn" id="loderButton"><i
                                              class="fa fa-spinner fa-pulse fa-fw" id="loderIcon"
                                              style="display:none;"></i>Register</button> */}
                    </div>
                </div>
                <div className="log-undre-text text-center my-2">
                    <p>
                        Already a user?
                        <a onClick={handleNavigation} >
                            <span>Login</span>
                        </a>{" "}
                    </p>
                </div>
            </form>

            <>
                {/* Modal */}
                <Modal className='modal' centered show={showModal} onHide={() => setShowModal(false)}

                >

                    {/* <div className="modal-content text-center"> */}
                    <Modal.Body className='text-center'>
                        <img src="/assets/img/user/okay-img.png" className="img-fluid" />
                        <p className='text-center'>
                        Your registration is under review and will be approved by the admin within 24 hours. If you do not receive an update, please check your spam folder as well
                        </p>
                        <Link to="/">
                            <button type="button" data-bs-dismiss="modal" className="btn btn-primary mt-4 px-4 mb-5">
                                Okay
                            </button>
                        </Link>
                    </Modal.Body>
                    {/* </div> */}

                </Modal>
            </>
        </div>

    )
}

export default TutorRegister